import React, {useEffect, useState} from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Label,
    Row,
    Button,
    Form,
    FormFeedback,
    Alert,
    Spinner
} from 'reactstrap';

import {useSelector, useDispatch} from "react-redux";

import {Link} from "react-router-dom";
import withRouter from "../common/withRouter";
import * as Yup from "yup";
import {useFormik} from "formik";

const Login = (props) => {
    const dispatch = useDispatch();
    const {error, loading} = useSelector(state => ({
        ...state
    }));

    const [userLogin, setUserLogin] = useState([]);
    const [showPassword, setShowPassword] = useState(false);


    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email || '',
            password: userLogin.password || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            console.log(values)
        }
    });
    document.title = "Sign In";
    return (
        <React.Fragment>
            <div>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div className="text-center mt-sm-5 mb-4 text-white-50">
                                <div>
                                    <Link to="/" className="d-inline-block auth-logo">
                                    </Link>
                                </div>
                                {/*<p className="mt-3 fs-15 fw-medium">Premium Admin & Dashboard Template</p>*/}
                            </div>
                        </Col>
                    </Row>

                    <Row className="justify-content-center">
                        <Col md={8} lg={6} xl={5}>
                            <Card className="mt-4">
                                <CardBody className="p-4">
                                    <div className="text-center mt-2">
                                        <h5 className="text-primary">Welcome Back !</h5>
                                        {/*<p className="text-muted">Sign in to continue to Velzon.</p>*/}
                                    </div>
                                    {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                    <div className="p-2 mt-4">
                                        <Form
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                            action="#">

                                            <div className="mb-3">
                                                <Label htmlFor="email" className="form-label">Email</Label>
                                                <Input
                                                    aria-label={"email"}
                                                    disabled={error ? null : loading ? true : false}
                                                    name="email"
                                                    className="form-control"
                                                    placeholder="Enter email"
                                                    type="email"
                                                    onChange={validation.handleChange}
                                                    onBlur={validation.handleBlur}
                                                    value={validation.values.email || ""}
                                                    invalid={
                                                        validation.touched.email && validation.errors.email ? true : false
                                                    }
                                                />
                                                {validation.touched.email && validation.errors.email ? (
                                                    <FormFeedback
                                                        type="invalid">{validation.errors.email}</FormFeedback>
                                                ) : null}
                                            </div>

                                            <div className="mb-3">
                                                <div className="float-end">
                                                    <Link to="/forgot-password" className="text-muted">Forgot
                                                        password?</Link>
                                                </div>
                                                <Label className="form-label"
                                                       htmlFor="password-input">Password</Label>
                                                <div className="position-relative auth-pass-inputgroup mb-3">
                                                    <Input
                                                        aria-label={"password"}
                                                        disabled={error ? null : loading ? true : false}
                                                        name="password"
                                                        value={validation.values.password || ""}
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control pe-5"
                                                        placeholder="Enter Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        invalid={
                                                            validation.touched.password && validation.errors.password ? true : false
                                                        }
                                                    />
                                                    {validation.touched.password && validation.errors.password ? (
                                                        <FormFeedback
                                                            type="invalid">{validation.errors.password}</FormFeedback>
                                                    ) : null}
                                                    <button
                                                        aria-label={"show password"}
                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted shadow-none"
                                                        onClick={() => setShowPassword(!showPassword)} type="button"
                                                        id="password-addon"><i
                                                        className="ri-eye-fill align-middle"></i></button>
                                                </div>
                                            </div>

                                            <div className="form-check">
                                                <Input className="form-check-input" type="checkbox" value=""
                                                       id="auth-remember-check"
                                                       disabled={error ? null : loading ? true : false}
                                                />
                                                <Label className="form-check-label" htmlFor="auth-remember-check">Remember
                                                    me</Label>
                                            </div>

                                            <div className="mt-4">
                                                <Button color="success"
                                                        aria-label={"sign in"}
                                                        disabled={error ? null : loading ? true : false}
                                                        className="btn btn-success w-100" type="submit">
                                                    {loading ? <Spinner size="sm"
                                                                        className='me-2'> Loading... </Spinner> : null}
                                                    Sign In
                                                </Button>
                                            </div>
                                        </Form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(Login);
